import * as React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles((theme) => ({
    snackbar: {
        zIndex: '1704 !important',
    }
}));
export function SnakbarAlertCommon({ CommonAlert, setCommonAlert }) {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {  
        setOpen(CommonAlert.apiErrorStatus)
    }, [CommonAlert.apiErrorStatus]);

    const classes = useStyles();
    React.useEffect(() => {
        setOpen(CommonAlert.apiErrorStatus)
    }, [CommonAlert.apiErrorStatus]);

    React.useEffect(() => {
        if (!open) {
            setCommonAlert({ apiErrorStatus: false, message: '' })
        }
    }, [open]);



    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );


    return (
        <Snackbar
            // style={{ backgroundColor:'red' }}
            classes={{ root: classes.snackbar }}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            message={CommonAlert.message}
            action={action}
        />
    );
}